import { Link, useLocation } from "react-router-dom";
import { Phone, CalendarCheck, GraduationCap, Briefcase } from "lucide-react";
import { CONTACT } from "@/lib/site";

const HIDDEN = ["/book", "/get-started", "/login", "/portal", "/payment"];

const Tab = ({ to, href, icon: Icon, label, active, gold, testid }) => {
  const cls = `flex flex-col items-center justify-center gap-1 h-14 rounded-xl text-[10px] tracking-[0.12em] uppercase font-semibold transition-colors duration-200 ${
    gold ? "bg-[#D4AF37] text-black" : active ? "text-[#D4AF37] bg-white/5" : "text-white/80 active:bg-white/10"}`;
  const inner = <><Icon className="w-5 h-5" strokeWidth={1.6} />{label}</>;
  return href
    ? <a href={href} className={cls} data-testid={testid} aria-label={`Call ${CONTACT.phone}`}>{inner}</a>
    : <Link to={to} className={cls} data-testid={testid}>{inner}</Link>;
};

export const MobileActionBar = () => {
  const { pathname } = useLocation();
  if (HIDDEN.some((p) => pathname.startsWith(p))) return null;
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-black/90 backdrop-blur-xl border-t border-[#D4AF37]/25 px-3 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] grid grid-cols-4 gap-2" data-testid="mobile-action-bar" aria-label="Quick links">
      <Tab to="/academy" icon={GraduationCap} label="Classes" active={pathname === "/academy"} testid="mobile-bar-classes" />
      <Tab to="/careers" icon={Briefcase} label="Careers" active={pathname === "/careers"} testid="mobile-bar-careers" />
      <Tab href={CONTACT.phoneHref} icon={Phone} label="Call" testid="mobile-bar-call" />
      <Tab to="/book" icon={CalendarCheck} label="Book" gold testid="mobile-bar-book" />
    </nav>
  );
};
